export default "__VITE_ASSET__BPPXCTes__"